// extracted by mini-css-extract-plugin
export default {"image":"image___c6235efe9dd83071eb7c","head":"head___db92ece83e6f540010d1","buttonWrap":"buttonWrap___c62a4a381b790807e6e0","button":"button___e074755dbecf1d3df934"};